export enum TypesBidEnum {
    STANDARD = 'STANDARD',
    FREE = 'FREE',
    BID = 'BID',
    WAITING_LIST = 'WAITING_LIST'
}
